import React from "react";
import ScreenSelector from "@icarius-common/screenSelector";
import paths from "@icarius-router/paths";
import {
  NineBoxSettingsIcon, NineBoxClassificationIcon
} from "@icarius-icons/index";
import { getLocalizedString } from "@icarius-localization/strings";

const Index = () => {

  const data = [
    {
      name: getLocalizedString("nineBoxSettings"),
      icon: <NineBoxSettingsIcon />,
      path: paths.nineBoxSettings,
    },
    {
      name: getLocalizedString("nineBoxClassification"),
      icon: <NineBoxClassificationIcon />,
      path: paths.nineBoxClassification,
    },
  ];

  return (
    <ScreenSelector
      title={getLocalizedString("talentClassification")}
      data={data}
    />
  );
}

export default Index;
